// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signin-container-wrapper[data-v-24809b85] {\n  height: 100%;\n}\n.signin-container-wrapper .input-text[data-v-24809b85] {\n  width: 20%;\n  min-width: 20rem;\n}\n.signin-container-wrapper .forgot-password-link[data-v-24809b85] {\n  width: -moz-fit-content;\n  width: fit-content;\n  align-self: center;\n}\n", ""]);
// Exports
module.exports = exports;
